import { render } from "./TableGrid.vue?vue&type=template&id=9f11e4a6&scoped=true"
import script from "./TableGrid.vue?vue&type=script&lang=js"
export * from "./TableGrid.vue?vue&type=script&lang=js"

import "./TableGrid.vue?vue&type=style&index=0&id=9f11e4a6&scoped=true&lang=css"

import exportComponent from "/mnt/gasoil_files/gasoil/docker/boletiland/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f11e4a6"]])

export default __exports__